module.exports = __webpack_public_path__ + "img/yayaphone.c0f76547.png";